export default function LocationsSection() {
  return (
    <section id="locations" className="bg-[#FAF8F5] py-24 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#FF6B35] text-xs font-semibold tracking-[0.25em] uppercase mb-3">Two Locations</p>
          <h2 className="text-[#1A1A1A] font-extrabold text-4xl md:text-5xl mb-4">
            Visit Our <span className="text-[#8B6F47]">Restaurants</span>
          </h2>
          <p className="text-[#1A1A1A]/60 text-base max-w-lg mx-auto">
            Two locations, one passion for great pizza. Find us on your South Iceland adventure.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Location 1 - Landvegamót */}
          <div className="bg-[#1A1A1A] rounded-3xl overflow-hidden group">
            <div className="relative h-64 overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/79ff7ea2-8c86-4f89-8525-06b9592dfb7b/daa163fa-388c-4d80-824c-70325cdb6590_1000028007.png?v=89a65c6d5126c5ed76d6d615e056e5da"
                alt="Gallery Pizza Landvegamót exterior"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/60 to-transparent" />
              <div className="absolute top-4 left-4 bg-[#FF6B35] text-[#1A1A1A] text-xs font-bold px-3 py-1.5 rounded-full">
                Main Location
              </div>
            </div>
            <div className="p-8">
              <h3 className="text-[#FAF8F5] font-extrabold text-2xl mb-1">Gallery Pizza</h3>
              <p className="text-[#FF6B35] font-semibold text-sm mb-5 tracking-wide">Landvegamót, Hella</p>

              <div className="flex flex-col gap-3 mb-7">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0">
                    <i className="ri-map-pin-line text-[#8B6F47] text-base" />
                  </div>
                  <div>
                    <p className="text-[#FAF8F5] text-sm font-medium">Landvegamót, Route 1</p>
                    <p className="text-[#FAF8F5]/50 text-xs">851 Hella, South Iceland</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0">
                    <i className="ri-time-line text-[#8B6F47] text-base" />
                  </div>
                  <div>
                    <p className="text-[#FAF8F5] text-sm font-medium">Open Daily</p>
                    <p className="text-[#FAF8F5]/50 text-xs">11:30 – 21:00</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0">
                    <i className="ri-phone-line text-[#8B6F47] text-base" />
                  </div>
                  <div>
                    <a href="tel:+3544878440" className="text-[#FAF8F5] text-sm font-medium hover:text-[#FF6B35] transition-colors">+354 487 8440</a>
                  </div>
                </div>
              </div>

              <a
                href="https://www.google.com/maps/place/Gallery+Pizza+Restaurant/@63.878272,-20.4890762,2807m/data=!3m1!1e3!4m6!3m5!1s0x48d6f1706cd78c71:0x4b9e682514311890!8m2!3d63.8794095!4d-20.500359!16s%2Fg%2F11md3xj6c5?entry=ttu&g_ep=EgoyMDI2MDQwNS4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#FF6B35] text-[#1A1A1A] font-bold text-sm px-6 py-3 rounded-full hover:bg-[#e55a24] transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-navigation-line" />
                Get Directions
              </a>
            </div>
          </div>

          {/* Location 2 - Hvolsvöllur */}
          <div className="bg-white rounded-3xl overflow-hidden group border border-[#1A1A1A]/8">
            <div className="relative h-64 overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/79ff7ea2-8c86-4f89-8525-06b9592dfb7b/f1203f01-d018-45cc-8e3c-5d264aa00dcf_485804502_1254722119989784_4575781051441691099_n.jpg?v=b8ecc83d37f3c3b3b73f472efae639e4"
                alt="Gallery Pizza Hvolsvöllur"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/40 to-transparent" />
              <div className="absolute top-4 left-4 bg-[#8B6F47] text-[#FAF8F5] text-xs font-bold px-3 py-1.5 rounded-full">
                Original Location
              </div>
            </div>
            <div className="p-8">
              <h3 className="text-[#1A1A1A] font-extrabold text-2xl mb-1">Gallery Pizza</h3>
              <p className="text-[#8B6F47] font-semibold text-sm mb-5 tracking-wide">Hvolsvöllur</p>

              <p className="text-[#1A1A1A]/60 text-sm leading-relaxed mb-5">
                Love our pizza? You can also visit us at our original restaurant in Hvolsvöllur — where it all began. Same great food, same warm atmosphere.
              </p>

              <div className="flex flex-col gap-3 mb-7">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0">
                    <i className="ri-map-pin-line text-[#8B6F47] text-base" />
                  </div>
                  <div>
                    <p className="text-[#1A1A1A] text-sm font-medium">860 Hvolsvöllur, Hvolsvegur 29</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0">
                    <i className="ri-time-line text-[#8B6F47] text-base" />
                  </div>
                  <div>
                    <p className="text-[#1A1A1A] text-sm font-medium">Open Daily</p>
                    <p className="text-[#1A1A1A]/50 text-xs">11:30 – 21:00</p>
                  </div>
                </div>
              </div>

              <a
                href="https://maps.google.com/?q=Hvolsvegur+29,+860+Hvolsvöllur,+Iceland"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 border-2 border-[#1A1A1A] text-[#1A1A1A] font-bold text-sm px-6 py-3 rounded-full hover:bg-[#1A1A1A] hover:text-[#FAF8F5] transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-navigation-line" />
                Get Directions
              </a>
            </div>
          </div>
        </div>

        {/* Map Embed */}
        <div className="mt-10 rounded-3xl overflow-hidden h-72">
          <iframe
            title="Gallery Pizza Landvegamót Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3!2d-20.0!3d63.8!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48d6b5a5a5a5a5a5%3A0x0!2sLandvegam%C3%B3t%2C+Hella%2C+Iceland!5e0!3m2!1sen!2sis!4v1700000000000!5m2!1sen!2sis"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}
